import { render, staticRenderFns } from "./ParcelItem.vue?vue&type=template&id=291dcce3&scoped=true&"
import script from "./ParcelItem.vue?vue&type=script&lang=ts&"
export * from "./ParcelItem.vue?vue&type=script&lang=ts&"
import style0 from "./ParcelItem.vue?vue&type=style&index=0&id=291dcce3&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "291dcce3",
  null
  
)

export default component.exports